import classNames from "classnames";
import { forwardRef, type PropsWithChildren } from "react";
import { Text } from "../text";
import { type InputProps } from "./input";
import { TimePicker, type TimePickerProps as AntTimePickerProps } from "antd";
import dayjs from "dayjs";
import { DEFAULT_TIME_FORMAT } from "utils/defines";

export type TimePickerProps = InputProps & AntTimePickerProps;

export const TimePickerInner = forwardRef<
  any,
  PropsWithChildren<TimePickerProps>
>(
  (
    {
      //children,
      //minimal,
      label,
      className,
      value,
      isDirty,
      isTouched,
      invalid,
      //error,
      onChange,
      ...inputProps
    },
    ref
  ) => {
    let type: any;
    const input = (
      <TimePicker
        ref={ref}
        {...inputProps}
        value={value ? dayjs(value, DEFAULT_TIME_FORMAT) : undefined}
        onChange={(v) => {
          onChange?.(
            (v ? dayjs(v).format(DEFAULT_TIME_FORMAT).toString() : null) as any
          );
        }}
      />
    );

    const content = (
      <label
        {...type}
        className={classNames(className, {
          error: invalid,
          touched: isTouched,
          dirty: isDirty,
        })}
      >
        {input}
        <Text>{label}</Text>
      </label>
    );

    return content;
  }
);
